// Theta Dynamics brand logomark (PNG, recoloured to brand blue).
export default function Logo({ size = 36, withWordmark = false, variant = "dark", className = "" }) {
  const wordmarkPrimary = variant === "light" ? "text-white" : "text-slate-900";
  const wordmarkSubtle = variant === "light" ? "text-slate-300" : "text-slate-500";

  return (
    <span className={`inline-flex items-center gap-3 ${className}`} aria-label="Theta Dynamics">
      <img
        src="/assets/theta-logo.png"
        alt="Theta Dynamics"
        width={size}
        height={size}
        className="block object-contain shrink-0"
        style={{ width: size, height: size }}
      />
      {withWordmark && (
        <span className="leading-tight">
          <span className={`block font-display font-bold tracking-tight ${wordmarkPrimary} text-base md:text-lg`}>
            Theta Dynamics
          </span>
          <span className={`block text-[10px] tracking-[0.25em] uppercase ${wordmarkSubtle} font-mono`}>
            Secure · Intelligent · Immersive
          </span>
        </span>
      )}
    </span>
  );
}
